import { render, staticRenderFns } from "./MessageBar.vue?vue&type=template&id=16c83be4&scoped=true"
import script from "./MessageBar.vue?vue&type=script&lang=js"
export * from "./MessageBar.vue?vue&type=script&lang=js"
import style0 from "./MessageBar.vue?vue&type=style&index=0&id=16c83be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c83be4",
  null
  
)

export default component.exports